import React from "react";
import { RiAttachment2 } from "react-icons/ri";
import { FaGithub, FaLinkedin } from "react-icons/fa";

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/ssonmali">
        <FaGithub />
      </a>
    </div>
    <div>
      <a href="http://www.linkedin.com/in/sanket-sonmali">
        <FaLinkedin />
      </a>
    </div>
    <div>
      <a href="https://drive.google.com/file/d/1Tor34lRVYTUvc7cuJ4q-lcx-zdaxWgfy/view?usp=drive_link">
        <RiAttachment2 />
      </a>
    </div>
  </div>
);

export default SocialMedia;
